import { SupportedLanguages } from "../i18next/language";
import { CompanyData } from "../../to-be-removed/LocalData/Company/CompanyData";
import { FirebaseData } from "../../to-be-removed/LocalData/General/FirebaseData";
import { LocalData } from "../../to-be-removed/LocalData/General/LocalData";
import { TranslationData } from "../../to-be-removed/LocalData/General/TranslationData";

export class ApiClientData extends FirebaseData {
  name: string = "";
  contactEmail: string = "";

  grantType: {
    clientCredentials: boolean;
  } = {
    clientCredentials: true,
  };
  defaultScopes: string[] = [];

  isPublic: boolean = false;
  requiresManualSetup: boolean = false;
  ownerCompanies: CompanyData[] = [];

  logoURL: string | undefined;
  description = new TranslationData();

  setup(data: any) {
    this.name = typeof data.name === "string" ? data.name : "";
    this.contactEmail = typeof data.contactEmail === "string" ? data.contactEmail : "";
    this.isPublic = typeof data.isPublic === "boolean" ? data.isPublic : false;
    this.ownerCompanies = Array.isArray(data.ownerCompanies)
      ? data.ownerCompanies.map((companyId: string) => LocalData.companies.addData(companyId))
      : [];
    this.defaultScopes = Array.isArray(data.defaultScopes) ? data.defaultScopes : [];
    this.requiresManualSetup = typeof data.requiresManualSetup === "boolean" ? data.requiresManualSetup : false;

    this.logoURL = typeof data.logoURL === "string" ? data.logoURL : undefined;
    this.description.setup(data.description, SupportedLanguages.EN);

    super.setup(data);
  }
}

